var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#021546","strokeWidth":"2.5"},[React.createElement("circle",{"cx":"12.9202","cy":"7.60005","r":"6.35005","key":0}),React.createElement("path",{"d":"m8.36005 12.4079-6.59229 6.5923","strokeLinecap":"round","key":1})]));
}

SearchInline.defaultProps = {"fill":"none","height":"21","viewBox":"0 0 21 21","width":"21"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
